import { Theme, BaseTheme } from '@dotcom/crown-ui';
import { ukTheme } from './uk/theme';

// Function to get the appropriate theme based on the current region
export const getCuiTheme = (): Theme => {
  const region = process.env.REACT_APP_THEME;
  switch (region) {
    case 'uk':
      return ukTheme;
    default:
      return BaseTheme;
  }
};
